
<div class="flow-form-field-wrapper" :inline="inline">
	<div v-if="$slots['label'] || $slots['info']" class="flow-form-field-label-wrapper">
		<!-- @slot Used to display label of form element -->
		<slot name="label" />
		<!-- @slot Used to display meta info of form element -->
		<slot name="info" />
	</div>
	<slot />
	<div v-if="$slots['help']" class="flow-form-field-help">
		<!-- @slot Used to display help text/ error / any message-->
		<slot name="help" />
	</div>
</div>
